import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// One-screen onboarding: language pills re-render the whole page in the tapped
// locale while carrying every not-yet-saved selection along as query params;
// the "I don't know yet" pill clears and dims the exam-date input.
export default class extends Controller {
  static targets = ["localeField", "dateInput", "unknownCheckbox"]

  switchLocale(event) {
    this.localeFieldTarget.value = event.params.locale

    const formData = new FormData(this.element)
    formData.delete("_method")
    formData.delete("authenticity_token")

    const query = new URLSearchParams(formData).toString()
    Turbo.visit(`${window.location.pathname}?${query}`)
  }

  toggleExamUnknown() {
    if (this.unknownCheckboxTarget.checked) {
      this.dateInputTarget.value = ""
      this.dateInputTarget.classList.add("opacity-45")
    } else {
      this.dateInputTarget.classList.remove("opacity-45")
    }
  }

  dateEntered() {
    if (this.dateInputTarget.value && this.unknownCheckboxTarget.checked) {
      this.unknownCheckboxTarget.checked = false
      this.dateInputTarget.classList.remove("opacity-45")
    }
  }
}
